module.exports = __webpack_public_path__ + "img/lock.73be99f7.png";